<template>
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
          <a-form-item label="权益名称">
            <a-input v-model="dataForm.name" allowClear placeholder="权益名称" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增权益</a-button>
          </a-form-item>
        </a-form>

        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="id"
          :loading="dataListLoading" :scroll="{ x: 800 }">
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.id)">
              编辑
            </a-button>
            <a-button type="link" class="btn-edit" @click="deleteHandle(row.id)">
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";

export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/benefittag/page",
        deleteURL: "/admin/benefittag/delete",
      },
      dataForm: {
        name: "",
      },
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          width: 80,
          align: "center",
        },
        {
          title: "权益名称",
          dataIndex: "name",
          width: 200,
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 180,
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 200,
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    query() {
      this.dataListLoading = true;
      this.$http
        .get(this.mixinViewModuleOptions.getDataListURL, {
          params: {
            page: this.page,
            limit: this.limit,
            ...this.dataForm,
          },
        })
        .then((res) => {
          this.dataListLoading = false;
          if (res.code !== 1) {
            this.dataList = [];
            this.total = 0;
            return this.$message.error(res.message);
          }
          this.dataList = res.data.list;
          this.total = res.data.total;
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
  },
};
</script>
